import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  if(window) { console.log = () => {}; console.debug = () => {}; console.warn = () => {}; console.info = () => {}; }
}

if ('cordova' in window) {
  const onDeviceReady = () => {
    platformBrowserDynamic().bootstrapModule(AppModule)
      .catch(err => console.error(err));
    // window.screen.orientation.lock('portrait');
  };
  document.addEventListener('deviceready', onDeviceReady, false);
}
else {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}

